import React, {ElementType, FC, Fragment} from 'react';
import useBreakpointMD from 'hooks/useBreakpointMD';
import AsyncMatchListItem from '../../Async/AsyncMatchListItem';
import {MatchGroup} from '../../../utils/types';

import './styles.scss';
import AdRepeated from '../AdRepeated';

interface MatchListProps {
  label?: string;
  showAds?: boolean;
  matchGroups: Record<string, MatchGroup>;
  ListItemRender?: ElementType;
}

const MatchList: FC<MatchListProps> = ({
  label,
  showAds = false,
  matchGroups,
  ListItemRender = AsyncMatchListItem,
}: MatchListProps) => {
  const isBreakpointMD = useBreakpointMD();
  return (
    <>
      {label && <h2 className="MatchList__label">{label}</h2>}
      {Object.entries(matchGroups).map(([competitionId, {title: groupTitle, groupings}], i) => (
        <Fragment key={competitionId}>
          <section className="MatchList__group">
            {groupTitle && <h3 className="MatchList__title">{groupTitle}</h3>}
            {Object.entries(groupings).map(([groupingId, {title: subTitle, matches}]) => (
              <div key={groupingId}>
                {subTitle && <h4 className="MatchList__subtitle">{subTitle}</h4>}
                {matches.map(match => (
                  <ListItemRender className="MatchList__match" match={match} key={match.matchId} />
                ))}
              </div>
            ))}
          </section>
          {
            /* only show ads between competitions if requested, not mobile and not at last position */
            showAds && !isBreakpointMD && i < Object.keys(matchGroups).length - 1 && (
              <AdRepeated
                adUnitRoot="sport24.gr/Matchcenter_hp_300x250"
                adUnitLetters={['A', 'B', 'C', 'D']}
                scope="matchlist"
                index={i}
                step={1}
                sizes={
                  i > 2
                    ? [
                        [320, 50],
                        [320, 100],
                      ]
                    : [
                        [300, 250],
                        [320, 100],
                        [320, 50],
                      ]
                }
              />
            )
          }
        </Fragment>
      ))}
    </>
  );
};

export default React.memo(MatchList);
